<template>
  <div
    :class="[
      'layer',
      { active: isActive },
      { primary: layer.type === 'DEMAND' },
      { accent: layer.type === 'SUPPLY' },
    ]"
    @click="
      setActiveLayer({
        layerId: layer.id,
        layerLevel: layer.type,
      })
    "
  >
    <icon size="16" v-if="isActive">visibility</icon>
    <icon size="16" v-else>visibility_off</icon>

    <div class="layerName ellipsis">{{ layer.name }}</div>
    <expand />
    <div class="metricContainer">
      <div v-if="layer.metricType === 'COUNT'" class="metricName">
        Total Count
      </div>
      <div v-else-if="layer.metricType === 'FREQUENCY'" class="metricName">
        Total Count
      </div>
      <div class="metricValue">
        {{ formattedValue(layer.value) || "0" }}
      </div>
    </div>
    <!-- Code for Edit/Delete: -->
    <!-- <div
      v-if="getMode === 'EDIT'"
      :class="[
        'controls flex-row-align-center',
        { primary: layer.type === 'DEMAND' },
        { accent: layer.type === 'SUPPLY' },
      ]"
    >
      <icon size="18" @click="handleEdit">edit</icon>
      <icon size="18" @click.stop="deleteLayer(layer.id)">delete</icon>
    </div> -->
  </div>
</template>

<script>
import { format } from "@/lib/numberFormatter";
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    layer: Object,
    isActive: Boolean,
  },
  computed: {
    ...mapGetters("SupplyDemand", ["getMode"]),
  },
  methods: {
    ...mapActions("Layers", ["setActiveLayer", "deleteLayer"]),
    formattedValue(value) {
      if (!value) return null;
      let v = parseFloat(value);
      v = isNaN(v) ? 0 : v;
      v = format(v.toFixed(3), 2);
      return v;
    },
  },
};
</script>

<style lang="scss" scoped>
.layer {
  padding: 10px;
  border-top: 1px solid var(--border-color);
  border-left: 3px solid transparent;
  display: flex;
  align-items: center;
  cursor: pointer;

  &.active.primary {
    border-left: 3px solid var(--color-primary);
    color: var(--color-primary);
  }

  &.active.accent {
    border-left: 3px solid var(--color-accent);
    color: var(--color-accent);
  }

  i {
    margin-right: 10px;
  }

  .metricContainer {
    display: flex;
    flex-direction: column;
    text-align: right;

    .metricName {
      font-size: 0.7em;
      line-height: 1.5em;
      color: var(--font-color);
    }

    .metricValue {
      font-size: 1.2em;
      margin-left: 10px;
    }
  }

  &:hover {
    /* background: var(--color-secondary-light); */
    .controls {
      /* opacity: 1 !important; */
      display: flex;
    }
  }

  .controls {
    /* opacity: 0; */
    display: none;
    margin-left: 10px;

    &.primary:hover {
      i:hover {
        background: var(--color-primary-light);
        color: var(--color-primary);
      }
    }

    &.accent:hover {
      i:hover {
        background: var(--color-accent-light);
        color: var(--color-accent);
      }
    }

    i {
      padding: 5px;
      margin: 0;
      border-radius: 50%;
      /* margin-left: 5px; */
      transition: 0.3s all ease-in-out;
      cursor: pointer;

      &:active {
        transform: scale(0.9);
      }

      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>
